module.exports = __webpack_public_path__ + "e-learning-app/static/img/zhuanxiang.30abef9.png";


//////////////////
// WEBPACK FOOTER
// ./src/module-course/img/tiku/zhuanxiang.png
// module id = 5mJc
// module chunks = 1